export class OOStyles {
	headerBgColor?: string;
	headerTextColor?: string;
	siteBgColor?: string;
	menuBgColor?: string;
	canvasItemCellBgColor?: string;
	canvasItemBorderColor?: string;
	menuGroupSelectedColor?: string;
	menuGroupDeselectedColor?: string;
	menuItemNameColor?: string;
	menuItemBoxShadow?: boolean;
	menuItemDescriptionColor?: string;
	menuItemDetailBgColor?: string;
	menuItemDetailNameColor?: string;
	menuItemDetailDescriptionColor?: string;
	menuItemDetailModGroupColor?: string;
	menuItemDetailModNameColor?: string;
	menuItemDetailModDescriptionColor?: string;
	checkBgColor?: string;
	checkItemNameColor?: string;
	checkModNameColor?: string;
	statusOrderAssembling: string;
	statusOrderPaymentAuth: string;
	statusOrderSubmitted: string;
	statusOrderQueued: string;
	statusOrderSentToPos: string;
	statusOrderInjected: string;
	statusOrderMobileCheckSave: string;
	kioskCanvasItemHeaderBgColor?: string;
	kioskCanvasItemBgColor?: string;
	kioskCanvasMenuBgColor?: string;
	kioskOrderStatusButtonBgColor?: string;
	kioskOrderStausButtonValueSeparatorColor?: string;
	cartButtonBackgroundColor: string;
	cartButtonTextColor: string;
	cartButtonIconPrefix: string;
	cartButtonIconName: string;
	canvasShowItemDescription: boolean;

	public constructor(init?: Partial<OOStyles>) {
		Object.assign(this, init);
	}
}
